<template>
    <q-page padding>
        <div class="q-display-1 q-mb-md text-secondary">
            <q-icon name="far fa-list-ul" class="q-mb-sm" /> {{ $t('configuration') }}
        </div>

        <q-tabs class="shadow-1 q-mt-md" color="secondary">
            <q-tab default slot="title" name="login" label="login" />
            <q-tab slot="title" name="register" label="register" />
            <q-tab slot="title" name="self_register" label="self_register" />
            <q-tab slot="title" name="user_profile" label="user_profile" />
            <q-tab slot="title" name="layout" label="layout" />
            <q-tab slot="title" :name="`c${client.id}`" :label="getClientName(client.id)" v-for="(client, index) in clients" :key="`t${index}`" v-if="disablegetClientName(client.id)" />

            <q-tab-pane name="login">
                <div class="row reverse gutter-md">
                    <div class="col-12" v-for="(item, index) in login" :key="index">
                        <q-field :helper="item.helper" v-if="item.type === 'boolean' || item.type === 'text'">
                            <q-input type="textarea" v-model="item.value" :float-label="item.label" v-if="item.type === 'text'" />

                            <q-select
                                v-model="item.value"
                                :options="[
                                    { value: true, label: 'true' },
                                    { value: false, label: 'false' }
                                ]"
                                :float-label="item.label"
                                v-if="item.type === 'boolean'"
                            />
                        </q-field>

                        <div class="row" v-if="item.type === 'color'">
                            <span class="q-caption text-faded">{{ $t('colors') }}</span>
                            <div class="col-12" v-for="(color, index) in item.value" :key="`c${index}`">
                                <q-field :helper="color.helper">
                                    <q-color v-model="color.value" :float-label="color.label" />
                                </q-field>
                            </div>
                        </div>

                        <div class="row" v-if="item.type === 'background_color'">
                            <div class="col-12">
                                <q-field :helper="item.helper">
                                    <q-color v-model="item.value" :float-label="item.label" />
                                </q-field>
                            </div>
                        </div>

                         <div class="row" v-if="item.type === 'font_color'">
                            <div class="col-12">
                                <q-field :helper="item.helper">
                                    <q-color v-model="item.value" :float-label="item.label" />
                                </q-field>
                            </div>
                        </div>

                        <div class="row" v-if="item.type === 'oauth2'">
                            <span class="q-caption text-faded">{{ $t('oauth2') }}</span>
                            <div class="col-12" v-for="(oauth2, index) in item.value" :key="`c${index}`">
                                <q-field :helper="oauth2.helper">
                                    <q-input v-model="oauth2.value" :float-label="oauth2.label" />
                                </q-field>
                            </div>
                        </div>

                        <div class="row" v-if="item.type === 'upload'">
                            {{  }}
                            <span class="q-caption text-faded">{{ item.label }}</span>
                            <div class="col-12">
                                <uploader content_type="images" @fileUploaded="imageUploaded" :multiple="false" :cropper="false" :item="item" :custom_directory="true" :filename="item.label" :slug="'login'" :aspect_ratio="getAspectNumber(item)" :aspect_ratio_string="getAspectString(item)" :no_expiration="true" />

                                <span class="q-caption text-faded">{{ item.helper }}</span>

                                <p v-if="item.value" class="q-mt-md file-url">
                                    <q-icon name="fal fa-check" color="positive" />
                                    <a :href="item.value" target="_blank"> {{ $truncateLink(item.value) }}</a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </q-tab-pane>

            <q-tab-pane name="register">
                <div class="row reverse gutter-sm">
                    <div class="col-12" v-for="(item, index) in register" :key="index">
                        <q-field :helper="item.helper" v-if="item.type === 'boolean' || item.type === 'text'">
                            <q-input type="textarea" v-model="item.value" :float-label="item.label" v-if="item.type === 'text'" />

                            <q-select
                                v-model="item.value"
                                :options="[
                                    { value: true, label: 'true' },
                                    { value: false, label: 'false' }
                                ]"
                                :float-label="item.label"
                                v-if="item.type === 'boolean'"
                            />
                        </q-field>

                        <div class="row" v-if="item.type === 'field'">
                            <span class="q-caption text-faded">{{ $t('fields') }}</span>
                            <div class="col-12" v-for="(field, index) in item.value" :key="`c${index}`">
                                <q-field :helper="field.helper">
                                    <q-select
                                        v-model="field.value"
                                        :options="[
                                            { value: true, label: 'true' },
                                            { value: false, label: 'false' }
                                        ]"
                                        :float-label="field.label"
                                    />
                                </q-field>
                            </div>
                        </div>

                        <div class="row" v-if="item.type === 'upload'">
                            <span class="q-caption text-faded">{{ item.label }}</span>
                            <div class="col-12">
                                <uploader content_type="images" @fileUploaded="imageUploaded" :multiple="false" :cropper="false" :item="item" :custom_directory="true" :filename="item.label" :slug="'login'" :aspect_ratio="getAspectNumber(item)" :aspect_ratio_string="getAspectString(item)" :no_expiration="true" />

                                <span class="q-caption text-faded">{{ item.helper }}</span>

                                <p v-if="item.value" class="q-mt-md file-url">
                                    <q-icon name="fal fa-check" color="positive" />
                                    <a :href="item.value" target="_blank"> {{ $truncateLink(item.value) }}</a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </q-tab-pane>

            <q-tab-pane name="self_register">
                <div class="row reverse gutter-sm">
                    <div class="col-12" v-for="(item, index) in self_register" :key="index">
                        <q-field :helper="item.helper" v-if="item.type === 'boolean' || item.type === 'text'">
                            <q-input type="textarea" v-model="item.value" :float-label="item.label" v-if="item.type === 'text'" />

                            <q-select
                                v-model="item.value"
                                :options="[
                                    { value: true, label: 'true' },
                                    { value: false, label: 'false' }
                                ]"
                                :float-label="item.label"
                                v-if="item.type === 'boolean'"
                            />
                        </q-field>

                        <div class="row" v-if="item.type === 'field'">
                            <span class="q-caption text-faded">{{ $t('fields') }}</span>
                            <div class="col-12" v-for="(field, index) in item.value" :key="`c${index}`">
                                <q-field :helper="field.helper">
                                    <q-select
                                        v-model="field.value"
                                        :options="[
                                            { value: true, label: 'true' },
                                            { value: false, label: 'false' }
                                        ]"
                                        :float-label="field.label"
                                    />
                                </q-field>
                            </div>
                        </div>

                        <div class="row" v-if="item.type === 'upload'">
                            <span class="q-caption text-faded">{{ item.label }}</span>
                            <div class="col-12">
                                <uploader content_type="images" @fileUploaded="imageUploaded" :multiple="false" :cropper="false" :item="item" :custom_directory="true" :filename="item.label" :slug="'login'" :aspect_ratio="getAspectNumber(item)" :aspect_ratio_string="getAspectString(item)" :no_expiration="true" />

                                <span class="q-caption text-faded">{{ item.helper }}</span>

                                <p v-if="item.value" class="q-mt-md file-url">
                                    <q-icon name="fal fa-check" color="positive" />
                                    <a :href="item.value" target="_blank"> {{ $truncateLink(item.value) }}</a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </q-tab-pane>

            <q-tab-pane name="user_profile">
                <div class="row reverse gutter-sm">
                    <div class="col-12" v-for="(item, index) in user_profile" :key="index">
                        <q-field :helper="item.helper" v-if="item.type === 'boolean' || item.type === 'text'">
                            <q-input type="textarea" v-model="item.value" :float-label="item.label" v-if="item.type === 'text'" />

                            <q-select
                                v-model="item.value"
                                :options="[
                                    { value: true, label: 'true' },
                                    { value: false, label: 'false' }
                                ]"
                                :float-label="item.label"
                                v-if="item.type === 'boolean'"
                            />
                        </q-field>

                        <div class="row" v-if="item.type === 'field'">
                            <span class="q-caption text-faded">{{ $t('fields') }}</span>
                            <div class="col-12" v-for="(field, index) in item.value" :key="`c${index}`">
                                <q-field :helper="field.helper">
                                    <q-select
                                        v-model="field.value"
                                        :options="[
                                            { value: true, label: 'true' },
                                            { value: false, label: 'false' }
                                        ]"
                                        :float-label="field.label"
                                    />
                                </q-field>
                            </div>
                        </div>

                        <div class="row" v-if="item.type === 'upload'">
                            <span class="q-caption text-faded">{{ item.label }}</span>
                            <div class="col-12">
                                <uploader content_type="images" @fileUploaded="imageUploaded" :multiple="false" :cropper="false" :item="item" :custom_directory="true" :filename="item.label" :slug="'login'" :aspect_ratio="getAspectNumber(item)" :aspect_ratio_string="getAspectString(item)" :no_expiration="true" />

                                <span class="q-caption text-faded">{{ item.helper }}</span>

                                <p v-if="item.value" class="q-mt-md file-url">
                                    <q-icon name="fal fa-check" color="positive" />
                                    <a :href="item.value" target="_blank"> {{ $truncateLink(item.value) }}</a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </q-tab-pane>

            <q-tab-pane name="layout">
                <div class="row reverse gutter-sm">
                    <div class="col-12" v-for="(item, index) in layout" :key="index">
                        <q-field :helper="item.helper" v-if="item.type === 'boolean' || item.type === 'text' || item.type === 'color'">
                            <q-input type="textarea" v-model="item.value" :float-label="item.label" v-if="item.type === 'text'" />

                            <q-color v-model="item.value" :float-label="item.label" v-if="item.type === 'color'" />

                            <q-select
                                v-model="item.value"
                                :options="[
                                    { value: true, label: 'true' },
                                    { value: false, label: 'false' }
                                ]"
                                :float-label="item.label"
                                v-if="item.type === 'boolean'"
                            />
                        </q-field>

                        <div class="row" v-if="item.type === 'upload'">
                            <span class="q-caption text-faded">{{ item.label }}</span>
                            <div class="col-12">
                                <uploader content_type="images" @fileUploaded="imageUploaded" :multiple="false" :cropper="false" :item="item" :custom_directory="true" :filename="item.label" :slug="'login'" :aspect_ratio="getAspectNumber(item)" :aspect_ratio_string="getAspectString(item)" :no_expiration="true" />

                                <span class="q-caption text-faded">{{ item.helper }}</span>

                                <p v-if="item.value" class="q-mt-md file-url">
                                    <q-icon name="fal fa-check" color="positive" />
                                    <a :href="item.value" target="_blank"> {{ $truncateLink(item.value) }}</a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </q-tab-pane>

            <q-tab-pane :name="`c${client.id}`" v-for="(client, index) in clients" :key="`p${index}`">
                <div class="row reverse gutter-md">
                    <div class="col-12" v-for="(item, index) in client.field" :key="index">
                        <q-field :helper="item.helper" v-if="item.type === 'boolean' || item.type === 'text'">
                            <q-input type="textarea" v-model="item.value" :float-label="item.label" v-if="item.type === 'text'" :disable="item.disabled" />

                            <q-select
                                v-model="item.value"
                                :options="[
                                    { value: true, label: 'true' },
                                    { value: false, label: 'false' }
                                ]"
                                :float-label="item.label"
                                v-if="item.type === 'boolean'"
                            />
                        </q-field>

                        <div class="row" v-if="item.type === 'color'">
                            <span class="q-caption text-faded">{{ $t('colors') }}</span>
                            <div class="col-12" v-for="(color, index) in item.value" :key="`c${index}`">
                                <q-field :helper="color.helper">
                                    <q-color v-model="color.value" :float-label="color.label" />
                                </q-field>
                            </div>
                        </div>

                        <div class="row" v-if="item.type === 'upload'">
                            <span class="q-caption text-faded">{{ item.label }}</span>
                            <div class="col-12">
                                <uploader content_type="images" @fileUploaded="imageUploaded" :multiple="false" :cropper="false" :item="item" :custom_directory="true" :filename="item.label" :slug="'clients'" :client_id="client.id" :aspect_ratio_string="getAspectString(item)" :no_expiration="true" />
                                <span class="q-caption text-faded">{{ item.helper }}</span>

                                <p v-if="item.value" class="q-mt-md file-url">
                                    <q-icon name="fal fa-check" color="positive" />
                                    <a :href="item.value" target="_blank"> {{ $truncateLink(item.value) }}</a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </q-tab-pane>
        </q-tabs>

        <div class="row gutter-sm justify-end q-mt-lg">
            <div class="col-xs-12 col-sm-3" :class="getOrder('cancel')">
                <q-btn color="tertiary" class="full-width" :label="$t('back')" icon="far fa-chevron-left" @click="$router.push({ name: 'admin_overview' })" />
            </div>

            <div class="col-xs-12 col-sm-3" :class="getOrder('save')">
                <q-btn color="secondary" class="full-width" :label="$t('save')" icon="far fa-save" @click="saveConfig()" />
            </div>
        </div>

        <q-modal v-model="show_new_configuration_selection" :content-css="{minWidth: '50vw'}">
            <q-modal-layout>
                <q-toolbar slot="header">
                    <q-btn flat round dense @click="hideNewConfiguration()" icon="fas fa-times" />
                    <q-toolbar-title>
                        {{ $t('add_configuration') }}
                    </q-toolbar-title>
                </q-toolbar>

                <div class="layout-padding">
                    <div class="row">
                        <div class="col-12">
                            <q-select :float-label="$t('type')" v-model="new_configuration_type" :options="new_configuration_types" />
                        </div>
                        <div class="col-12">
                            <q-input :float-label="$t('slug')" v-model="new_configuration_slug" />
                        </div>
                    </div>

                    <div class="row gutter-sm justify-end q-mt-lg">
                        <div class="col-xs-12 col-sm-3">
                            <q-btn color="tertiary" class="full-width" :label="$t('cancel')" icon="far fa-ban" @click="hideNewConfiguration()" />
                        </div>

                        <div class="col-xs-12 col-sm-3">
                            <q-btn color="secondary" class="full-width" :label="$t('add')" icon="far fa-save"  @click="addNewConfiguration()" />
                        </div>
                    </div>
                </div>
            </q-modal-layout>
        </q-modal>
    </q-page>
</template>

<script>
import { mapGetters } from 'vuex'
import Uploader from 'components/Uploader'

export default {
    i18nOptions: { namespaces: ['common', 'admin'] },

    data() {
        return {
            clients: [],
            login: [],
            new_configuration_slug: '',
            new_configuration_target: null,
            new_configuration_type: null,
            new_configuration_types: [{
                label: 'text',
                value: 'text'
            }, {
                label: 'boolean',
                value: 'boolean'
            }, {
                label: 'upload',
                value: 'upload'
            }],
            register: [],
            self_register: [],
            show_new_configuration_selection: false,
            user_profile: [],
            layout: []
        }
    },

    components: {
        'uploader': Uploader,
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            user_clients: 'common/user_clients',
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },
    },

    methods: {
        fetchAll() {
            this.$q.loading.show()

            this.$axios.all([this.fetchConfig(), this.fetchDescriptions()])
            .then(this.$axios.spread((response, description) => {
                let keys_login = Object.keys(response.data.login)
                for (const key of keys_login) {
                    let value = null
                    let value_object = []
                    let type = ''

                    if (key === 'colors') {
                        let keys_colors = Object.keys(response.data.login.colors)

                        for (const key_color of keys_colors) {
                            value_object.push({
                                label: key_color,
                                value: response.data.login.colors[key_color],
                                helper: description.data.login.colors[key_color],
                                error: false,
                            })
                        }

                        this.login.push({
                            label: key,
                            value: value_object,
                            error: false,
                            helper: description.data.login[key],
                            type: 'color'
                        })
                    }
                    else if (key === 'oauth2') {
                        response.data.login.oauth2.forEach((element, index) => {
                            let keys_oauth = Object.keys(element)

                            for (const key_oauth of keys_oauth) {
                                value_object.push({
                                    label: key_oauth,
                                    value: element[key_oauth],
                                    helper: '',
                                    error: false,
                                })
                            }

                            this.login.push({
                                label: key,
                                value: value_object,
                                error: false,
                                helper: '',
                                type: 'oauth2',
                                index: index
                            })
                        })
                    }
                    else if(key === 'background_color') {
                        value = response.data.login[key]
                        this.login.push({
                            label: key,
                            value: value,
                            error: false,
                            helper: description.data.login.background_color,
                            type: 'background_color'
                        })
                    }
                    else if(key === 'font_color') {
                        value = response.data.login[key]
                        this.login.push({
                            label: key,
                            value: value,
                            error: false,
                            helper: description.data.login.font_color,
                            type: 'font_color'
                        })
                    }
                    else {
                        value = response.data.login[key]

                        this.login.push({
                            label: key,
                            value: value,
                            error: false,
                            helper: description.data.login[key],
                            type: this.getType(value)
                        })
                    }
                }

                let keys_register = Object.keys(response.data.register)
                for (const key of keys_register) {
                    let value = null
                    let value_object = []

                    if (typeof(response.data.register[key]) === 'object' && response.data.register[key] != null) {
                        let keys_fields = Object.keys(response.data.register[key])

                        for (const key_field of keys_fields) {
                            value_object.push({
                                label: key_field,
                                value: response.data.register[key][key_field],
                                helper: description.data.register.fields[key_field],
                                error: false,
                            })
                        }
                    }
                    else {
                        value = response.data.register[key]
                    }

                    this.register.push({
                        label: key,
                        value: value_object.length > 0 ? value_object : value,
                        error: false,
                        helper: value_object.length > 0 ? '' : description.data.register[key],
                        type: value_object.length > 0 ? 'field' : this.getType(value)
                    })
                }

                let keys_self_register = Object.keys(response.data.self_register)
                for (const key of keys_self_register) {
                    let value = null
                    let value_object = []

                    if (typeof(response.data.self_register[key]) === 'object' && response.data.self_register[key] != null) {
                        let keys_fields = Object.keys(response.data.self_register[key])

                        for (const key_field of keys_fields) {
                            value_object.push({
                                label: key_field,
                                value: response.data.self_register[key][key_field],
                                helper: description.data.self_register.fields[key_field],
                                error: false,
                            })
                        }
                    }
                    else {
                        value = response.data.self_register[key]
                    }

                    this.self_register.push({
                        label: key,
                        value: value_object.length > 0 ? value_object : value,
                        error: false,
                        helper: value_object.length > 0 ? '' : description.data.self_register[key],
                        type: value_object.length > 0 ? 'field' : this.getType(value)
                    })
                }

                let keys_user_profile = Object.keys(response.data.user_profile)
                for (const key of keys_user_profile) {
                    let value = null
                    let value_object = []

                    if (typeof(response.data.user_profile[key]) === 'object' && response.data.user_profile[key] != null) {
                        let keys_fields = Object.keys(response.data.user_profile[key])

                        for (const key_field of keys_fields) {
                            value_object.push({
                                label: key_field,
                                value: response.data.user_profile[key][key_field],
                                helper: description.data.user_profile.fields[key_field],
                                error: false,
                            })
                        }
                    }
                    else {
                        value = response.data.user_profile[key]
                    }

                    this.user_profile.push({
                        label: key,
                        value: value_object.length > 0 ? value_object : value,
                        error: false,
                        helper: value_object.length > 0 ? '' : description.data.user_profile[key],
                        type: value_object.length > 0 ? 'field' : this.getType(value)
                    })
                }

                let keys_layout = Object.keys(response.data.layout)
                for (const key of keys_layout) {
                    let value = null
                    let value_object = []
                    let upload_list = ['footer_social_1_image', 'footer_social_2_image', 'footer_social_3_image', 'footer_social_4_image']
                    let color_list = ['footer_background_color', 'footer_text_color']
                    let boolean_list = ['footer_custom']

                    if (typeof(response.data.layout[key]) === 'object' && response.data.layout[key] != null) {
                        let keys_fields = Object.keys(response.data.layout[key])

                        for (const key_field of keys_fields) {
                            value_object.push({
                                label: key_field,
                                value: response.data.layout[key][key_field],
                                helper: description.data.layout.fields[key_field],
                                error: false,
                            })
                        }
                    }
                    else {
                        value = response.data.layout[key]
                    }

                    let type = 'text'
                    if (upload_list.includes(key)) type = 'upload'
                    else if (color_list.includes(key)) type = 'color'
                    else if (boolean_list.includes(key)) type = 'boolean'

                    this.layout.push({
                        label: key,
                        value: value_object.length > 0 ? value_object : value,
                        error: false,
                        helper: value_object.length > 0 ? '' : description.data.layout[key],
                        type: type
                    })
                }

                response.data.clients.forEach(client => {
                    let fields = []
                    let id = ''

                    let keys_client = Object.keys(client)
                    for (const key of keys_client) {
                        let value = null
                        let value_object = []

                        if (typeof(client[key]) === 'object' && client[key] != null) {
                            let keys_colors = Object.keys(client[key])

                            for (const key_color of keys_colors) {
                                value_object.push({
                                    label: key_color,
                                    value: client[key][key_color],
                                    helper: description.data.clients.colors[key_color],
                                    error: false,
                                })
                            }
                        }
                        else {
                            value = client[key]
                        }

                        if (key === 'id') id = client[key]

                        fields.push({
                            label: key,
                            value: value_object.length > 0 ? value_object : value,
                            disabled: key === 'id' ? true : false,
                            helper: value_object.length > 0 ? '' : description.data.clients[key],
                            error: false,
                            type: value_object.length > 0 ? 'color' : this.getType(value)
                        })
                    }

                    this.clients.push({id: id, field: fields})
                })
            }))
            .catch(e => {
                console.log(e)
            })
            .finally(() => {
                this.$q.loading.hide()
            })
        },

        fetchConfig() {
            return this.$axios.get('/clients/config/', this.getHeader)
        },

        fetchDescriptions() {
            return this.$axios.get('/clients/config/descriptions/', this.getHeader)
        },

        saveConfig() {
            let login = {}
            let colors = {}
            let oauth2 = []

            this.login.forEach(field => {
                login[field.label] = field.value

                if (field.type === 'color') {
                    field.value.forEach(element => {
                        colors[element.label] = element.value
                    })
                }
                else if (field.type === 'oauth2') {
                    let new_oauth2 = {}

                    field.value.forEach(element => {
                        new_oauth2[element.label] = element.value
                    })

                    oauth2.push(new_oauth2)
                }
                else {
                    let value = field.value
                    if (field.type === 'upload') value = field.value.split('?')[0]
                    login[field.label] = value
                }
            })

            login['colors'] = colors
            login['oauth2'] = oauth2

            let register = {}
            let fields = {}

            this.register.forEach(field => {
                register[field.label] = field.value

                if (field.type != 'field') register[field.label] = field.value
                else{
                    field.value.forEach(element => {
                        fields[element.label] = element.value
                    })
                }
            })

            register['fields'] = fields

            let self_register = {}
            let fields_self_register = {}

            this.self_register.forEach(field => {
                self_register[field.label] = field.value

                if (field.type != 'field') self_register[field.label] = field.value
                else {
                    field.value.forEach(element => {
                        fields_self_register[element.label] = element.value
                    })
                }
            })

            self_register['fields'] = fields_self_register

            let user_profile = {}
            let fields_user_profile = {}

            this.user_profile.forEach(field => {
                user_profile[field.label] = field.value

                if (field.type != 'field') user_profile[field.label] = field.value
                else{
                    field.value.forEach(element => {
                        fields_user_profile[element.label] = element.value
                    })
                }
            })

            user_profile['fields'] = fields_user_profile

            let layout = {}
            let fields_layout = {}

            this.layout.forEach(field => {
                layout[field.label] = field.value

                if (field.type != 'field') layout[field.label] = field.value
                else{
                    field.value.forEach(element => {
                        fields_layout[element.label] = element.value
                    })
                }
            })

            let clients = []

            this.clients.forEach(client_raw => {
                colors = {}
                let client = {}

                client_raw.field.forEach(field => {
                    if (field.type != 'color') {
                        let value = field.value
                        if (field.type === 'upload') value = field.value.split('?')[0]
                        client[field.label] = value
                    } 
                    else{
                        field.value.forEach(element => {
                            colors[element.label] = element.value
                        })
                    }
                })

                client['colors'] = colors
                clients.push(client)
            })

            let data = {
                'slugs': [
                    {
                        'slug': 'clients',
                        'clients': clients
                    },
                    {
                        'slug': 'login',
                        'login': login
                    },
                    {
                        'slug': 'user_profile',
                        'user_profile': user_profile
                    },
                    {
                        'slug': 'register',
                        'register': register
                    },
                    {
                        'slug': 'self_register',
                        'self_register': self_register
                    },
                    {
                        'slug': 'layout',
                        'layout': layout
                    }
                ]
            }

            this.$axios.post('/clients/config/', data, this.getHeader)
	        .then(response => {
                this.$q.loading.hide()

                this.$q.notify({
                    message: this.$t('config_save_successfully'),
                    type: 'positive',
                    icon: 'fal fa-save'
                })
            })
            .catch(e => {
                this.$q.loading.hide()
            })
        },

        getClientName(id) {
            let obj = this.user_clients.find((obj) => { return obj.id === id })
            if (obj) return obj.name
            else return ''
        },

        disablegetClientName(id) {
            let obj = this.user_clients.find((obj) => { return obj.id === id })
            if (obj) return true
            else return false
        },

        getType(value) {
            var pattern = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/

            if(!pattern.test(value)) {
                if (typeof(value) === 'boolean') return 'boolean'
                else return 'text'
            }
            else return 'upload'
        },

        imageUploaded(url, item) {
            item.value = url.split("?")[0]
        },

        newConfiguration(target) {
            this.new_configuration_target = target
            this.show_new_configuration_selection = true
        },

        addNewConfiguration() {
            if (this.new_configuration_type && this.new_configuration_slug) {
                if (this.new_configuration_target === 'login') {
                    let key_unique = true

                    let obj = this.login.find((obj) => { return obj.label === this.new_configuration_slug })
                    if (obj) key_unique = false

                    if (key_unique) {
                        this.login.push({
                            label: this.new_configuration_slug,
                            value: null,
                            error: false,
                            type: this.new_configuration_type
                        })
                    }
                }
                else if (this.new_configuration_target === 'register') {
                    let key_unique = true

                    let obj = this.register.find((obj) => { return obj.label === this.new_configuration_slug })
                    if (obj) key_unique = false

                    if (key_unique) {
                        this.self_register.push({
                            label: this.new_configuration_slug,
                            value: null,
                            error: false,
                            type: this.new_configuration_type
                        })
                    }
                }
                else if (this.new_configuration_target === 'self_register') {
                    let key_unique = true

                    let obj = this.self_register.find((obj) => { return obj.label === this.new_configuration_slug })
                    if (obj) key_unique = false

                    if (key_unique) {
                        this.self_register.push({
                            label: this.new_configuration_slug,
                            value: null,
                            error: false,
                            type: this.new_configuration_type
                        })
                    }
                }
                else if (this.new_configuration_target === 'user_profile') {
                    let key_unique = true

                    let obj = this.user_profile.find((obj) => { return obj.label === this.new_configuration_slug })
                    if (obj) key_unique = false

                    if (key_unique) {
                        this.user_profile.push({
                            label: this.new_configuration_slug,
                            value: null,
                            error: false,
                            type: this.new_configuration_type
                        })
                    }
                }
                else {
                    let obj = this.clients.find((obj) => { return obj.id === this.new_configuration_target })
                    if (obj) {
                        let key_unique = true

                        let obj_key = this.login.find((obj_key) => { return obj_key.label === this.new_configuration_slug })
                        if (obj_key) key_unique = false

                        if (key_unique) {
                            obj.field.push({
                                label: this.new_configuration_slug,
                                value: null,
                                error: false,
                                type: this.new_configuration_type,
                                disabled: false
                            })
                        }
                    }
                }

                this.hideNewConfiguration()
            }
        },

        hideNewConfiguration() {
            this.new_configuration_target = null
            this.new_configuration_type = null
            this.new_configuration_slug = ''
            this.show_new_configuration_selection = false
        },

        getOrder(name) {
            if (name == 'cancel') {
                if (this.$q.platform.is.mobile) return 'order-last'
                else return 'order-first'
            }
            else if (name == 'save') {
                if (this.$q.platform.is.mobile) return 'order-first'
                else return 'order-last'
            }
        },

        getAspectNumber(item) {
            switch(item.label) {
                case 'background': return 140/113
                break
                case 'email_logo': return 600/109
                break
                case 'logo_en': 
                case 'logo_es': 
                case 'logo_fr': 
                case 'logo_pt': 
                case 'logo': 
                case 'logo_mobile_en': 
                case 'logo_mobile_es': 
                case 'logo_mobile_fr': 
                case 'logo_mobile_pt': 
                case 'logo_mobile': 
                case 'email_logo': return 395/47
                break
                case 'logo_footer_fr': 
                case 'logo_footer_pt': 
                case 'logo_footer_es': 
                case 'logo_footer_en': 
                case 'logo_footer': return 395/100
                break
                case 'footer_social_1_image':
                case 'footer_social_2_image':
                case 'footer_social_3_image':
                case 'footer_social_4_image': return 1/1
                case 'full_background': return 16/9
                break
                case 'default_background_certificate': return 877/620
                break
                case 'group_library_file_placeholder':
                case 'group_training_placeholder':
                case 'live_class_placeholder':
                case 'news_placeholder':
                case 'podcast_placeholder':
                case 'presential_event_placeholder':
                case 'user_avatar_placeholder':
                case 'webcast_placeholder': return 52/29
                break
                case 'user_avatar_placeholder': return 650/650
                break
                case 'home_banner': return 1600/340
                break
                default: return 1280/720
                break
            }
        },

        getAspectString(item) {
            switch(item.label) {
                case 'background': return '140/113'
                break
                case 'logo': 
                case 'logo_en': 
                case 'logo_es': 
                case 'logo_fr':
                case 'logo_pt':
                case 'logo_mobile': 
                case 'logo_mobile_en': 
                case 'logo_mobile_es': 
                case 'logo_mobile_fr': 
                case 'logo_mobile_pt': 
                case 'email_logo': return '395/47'
                break
                case 'logo_footer_fr': 
                case 'logo_footer_pt': 
                case 'logo_footer_es': 
                case 'logo_footer_en': 
                case 'logo_footer': return '395/100'
                break
                case 'footer_social_1_image':
                case 'footer_social_2_image':
                case 'footer_social_3_image':
                case 'footer_social_4_image': return '1/1'
                case 'full_background': return '16/9'
                break
                case 'default_background_certificate': return '877/620'
                break
                case 'group_library_file_placeholder':
                case 'group_training_placeholder':
                case 'live_class_placeholder':
                case 'news_placeholder':
                case 'podcast_placeholder':
                case 'presential_event_placeholder':
                case 'user_avatar_placeholder':
                case 'webcast_placeholder': return '52/29'
                break
                case 'user_avatar_placeholder': return '650/650'
                break
                case 'home_banner': return '1600/340'
                break
                default: return '1280/720'
                break
            }
        }
    },

    created() {
        this.fetchAll()
    }
}
</script>

<style lang="stylus" scoped>
@import '~variables'

.file-url
    a
        text-decoration none
        color black
</style>
